import { storyblokEditable } from "@storyblok/react";
import ListItem from "./ListItem";

const BrandsHeaderBigLogos = ({ blok }) => (
  <div className="wrap">
    <div
      className="brandsheaderbiglogo-wrap inner-wrap flex items-center"
      {...storyblokEditable(blok)}
    >
      <div className="brandsheaderbiglogo-wrap-content flex">
        <div className="brandsheaderbiglogo-left">
          {/*     <img src={blok.logo.filename} alt={blok.logo.alt} /> */}
          <div className="brandsheaderbiglogo-img-box">
          <img
              className="brandsheaderbiglogo-logo hide-mobile"
              src={blok.logo.filename}
              alt={blok.logo.alt}
            />
                <img
            className="brandsheaderbiglogo-logo hide-desktop"
            src={blok.logo.filename}
            alt={blok.logo.alt}
          />
          </div>
          <h2 className="brandsheaderbiglogo-branding text-2xl">
            {blok.slogan}
          </h2>
          <div>
       

            <img
              className="brandsheaderbiglogo-mobileimg hide-mobile"
              src={blok.image.filename}
              alt={blok.image.alt}
            />
          </div>

         {blok.infotext && (<p className="brandsheaderbiglogo-infotext pb-3">{blok.infotext}</p>)} 
         {blok.infotext2 && (<p className="brandsheaderbiglogo-infotext pb-3">{blok.infotext2}</p>)} 
         {blok.infotext3 && (<p className="brandsheaderbiglogo-infotext pb-3">{blok.infotext3}</p>)} 
         {blok.infotext4 && (<p className="brandsheaderbiglogo-infotext pb-3">{blok.infotext4}</p>)} 
         {blok.infotext5 && (<p className="brandsheaderbiglogo-infotext">{blok.infotext5}</p>)} 
         
          <ul className="brandsheaderbiglogo-list">
            <ListItem blok={blok} />
          </ul>
        </div>
        <div className="brandsheaderbiglogo-right ml-16">
      

          <img
            className="hide-desktop brandsheaderbiglogo-rightimage"
            src={blok.image.filename}
            alt={blok.image.alt}
          />
        </div>
      </div>
    </div>
  </div>
);
export default BrandsHeaderBigLogos;
